import { post,get,put } from "../api_helper";
 import { RECUITER } from "../url_helper";

 
 
 
 export const getAllRecuiterApi =(RECUITER_ID)=> get(`${RECUITER}/${RECUITER_ID}`);
 export const saverecuiterapi =({payload,recuiterId})=> put(`${RECUITER}/${recuiterId}`,payload);
 